<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit User</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
        <CustomEdit v-else></CustomEdit>   
    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Users/MenuList.vue";
import lang from "@/views/modules/Users/language/en";
import GenericEdit from "@/components/layout/shared/generic/EditView.vue";
import CustomEdit from "@/views/modules/Users/EditView.vue";

export default {
name: "edit-users",
components: {
        breadcrumbs, 
        GenericEdit,
        CustomEdit,
    },
    data(){
        return {
            generic: false,
            metaList:[
                {
                    type:'text',
                    name:'first_name',
                    label: lang.LBL_FIRST_NAME,
                    required: true
                },
                {
                    type:'text',
                    name:'last_name',
                    label: lang.LBL_LAST_NAME,
                    required: false
                },
                {
                    type:'text',
                    name:'username',
                    label: lang.LBL_USER_NAME,
                    required: true
                }, 
                {
                    type:'text',
                    name:'email',
                    label: lang.LBL_USER_EMAIL,
                    required: true
                }, 
                {
                    type:'text',
                    name:'phone',
                    label: lang.LBL_PHONE,
                    required: true
                },
                {
                    type:'password',
                    name:'password',
                    label: lang.LBL_USER_PASSWORD,
                    required: false
                },
                {
                    type:'selectbox',
                    name:'status',
                    label: lang.LBL_USER_STATUS,
                    dom_access:true,
                    dom_key:'status_dom',
                    required: true
                },
                {
                    type:'selectcomponent',
                    name:'user-role_name',
                    label: lang.LBL_ROLE,
                    required: false,
                    linkComponent:'user-role',
                    parent_id:'role_id',
                    parent_type:'parent_type',
                },
                {
                    type:'uploadfile',
                    name:'user_image',
                    label: lang.LBL_USER_IMAGE,
                    required: false
                }             
               
            ],
            urls:'api/modules/users',
            
            routePath:{
                path:'users',
                detail:false
            }
            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
           
        }
    },
}
</script>